import React from 'react'
import Image from 'components/image'

const size = 100

interface IconProps {
  icon: string
  block: boolean
  alt: string
}

function Icon({ icon, block, alt }: IconProps) {
  return (
    <Image
      alt={alt}
      height={size}
      lazyLoad={false}
      src={`//images.babylist.com/image/upload/c_scale,w_${size}/onboarding-icons/${icon}.svg`}
      style={{ display: block ? 'block' : 'inline-block' }}
    />
  )
}

export function AdoptionIcon(props: any) {
  return <Icon alt="adoption" icon="adoption" {...props} />
}

export function JourneyIcon(props: any) {
  return <Icon alt="hands" icon="hands" {...props} />
}

export function PregnancyIcon(props: any) {
  return <Icon alt="pregnant woman" icon="pregnancy" {...props} />
}

export function SurrogacyIcon(props: any) {
  return <Icon alt="surrogacy" icon="surrogacy-2" {...props} />
}

export function KindergartenIcon(props: any) {
  return <Icon alt="apple" icon="apple" {...props} />
}

export function StillTryingIcon(props: any) {
  return <Icon alt="still trying" icon="stilltrying-2" {...props} />
}

export function GameBoyIcon(props: any) {
  return <Icon alt="gameboy" icon="gameboy" {...props} />
}

export function OverwhelmedIcon(props: any) {
  return <Icon alt="overwhelmed" icon="overwhelmed-2" {...props} />
}
export function ExcitedIcon(props: any) {
  return <Icon alt="excited" icon="excited-2" {...props} />
}

export function ExploringIcon(props: any) {
  return <Icon alt="just exploring" icon="exploring-2" {...props} />
}

export function InspirationIcon(props: any) {
  return <Icon alt="bear" icon="bear_green" {...props} />
}

export function ResearchIcon(props: any) {
  return <Icon alt="stroller" icon="stroller_tangerine" {...props} />
}

export function AddItemsIcon(props: any) {
  return <Icon alt="clipboard" icon="clipboard_blue" {...props} />
}

export function YouGotThisIcon(props: any) {
  return <Icon alt="muscles" icon="muscle" {...props} />
}

export function InviteSentIcon(props: any) {
  return <Icon alt="email sent" icon="emailsent" {...props} />
}

export function HeckYesIcon(props: any) {
  return <Icon alt="yes" icon="heckyes" {...props} />
}

export function NotNowIcon(props: any) {
  return <Icon alt="not now" icon="notnow" {...props} />
}

export function AllSetIcon(props: any) {
  return <Icon alt="rocket" icon="rocket" {...props} />
}

export function NewListIcon(props: any) {
  return <Icon alt="New List" icon="new_list" {...props} />
}

export function CopyListIcon(props: any) {
  return <Icon alt="Copy List" icon="copy_list" {...props} />
}

export function CarriageIcon(props: any) {
  return <Icon alt="Baby Carriage" icon="carriage" {...props} />
}

export function BagIcon(props: any) {
  return <Icon alt="Bag" icon="bag" {...props} />
}

export default Icon
